import './styles.scss';
import React, {Component} from 'react';
import {createClassName} from '../../util/utility';

export interface AppErrorMessageDataProps {
  message: string;
  className?: string;
  onMouseOut?: any;
}

function AppErrorMessage({
  className,
  message,
  onMouseOut,
}: AppErrorMessageDataProps) {
  const classes = createClassName('app-error-message', className);
  return (
    <div onMouseOut={onMouseOut} className={classes}>
      {message}
    </div>
  );
}

export default AppErrorMessage;
